// GERADO por scripts/design/extract.mjs — nao editar a mao.
// Fonte: design/remote/*.dc.html (workspace claude.ai/design).

export const tokens = {
  "color": {
    "background": "#F6F7FB",
    "text": "#23305E",
    "primary": "#1B4DF5",
    "primaryHover": "#1439C8",
    "primaryBorder": "#C3D0FB",
    "surface": "#FFFFFF",
    "border": "#E7EAF6",
    "primaryTint3": "#F2F5FF",
    "primaryTint2": "#DAE2FD",
    "focusHalo": "rgba(27,77,245,0.12)",
    "background2": "#FAFBFE",
    "textSubtle": "#47548C",
    "primaryTint": "#E6EBFE",
    "textStrong": "#0C1230",
    "textMuted": "#6B76A3",
    "onPrimary": "#FFFFFF",
    "background3": "#F0F2F9",
    "focusHalo2": "rgba(27,77,245,0.20)",
    "success": "#19B27B",
    "successDeep": "#0F8A5F",
    "warning": "#E09112",
    "warningDeep": "#A66B0D",
    "warningBorder": "#F8DFAE",
    "warningSurface": "#FFF8ED",
    "danger": "#E5484D",
    "dangerDeep": "#C93A3F",
    "dangerBorder": "#F0AEB1",
    "dangerSurface": "#FEF2F2",
    "info": "#2563EB"
  },
  "theme": {
    "seed": "#1B4DF5",
    "halo": {
      "focusHalo": 12,
      "focusHalo2": 20
    },
    "light": {
      "colors": {
        "primary": "#1B4DF5",
        "primaryHover": "#1439C8",
        "primaryTint": "#E6EBFE",
        "primaryTint2": "#DAE2FD",
        "primaryTint3": "#F2F5FF",
        "primaryBorder": "#C3D0FB",
        "onPrimary": "#FFFFFF",
        "background": "#F6F7FB",
        "background2": "#FAFBFE",
        "background3": "#F0F2F9",
        "surface": "#FFFFFF",
        "border": "#E7EAF6",
        "textStrong": "#0C1230",
        "text": "#23305E",
        "textSubtle": "#47548C",
        "textMuted": "#6B76A3"
      },
      "recipes": {
        "primaryHover": {
          "pct": 84,
          "base": "#000000"
        },
        "primaryTint": {
          "pct": 11,
          "base": "#FFFFFF"
        },
        "primaryTint2": {
          "pct": 15,
          "base": "#FFFFFF"
        },
        "primaryTint3": {
          "pct": 5,
          "base": "#FFFFFF"
        },
        "primaryBorder": {
          "pct": 24,
          "base": "#FFFFFF"
        }
      }
    },
    "dark": {
      "colors": {
        "primary": "#7DA6FF",
        "primaryHover": "#9BBBFF",
        "primaryTint": "#172869",
        "primaryTint2": "#182C77",
        "primaryTint3": "#152152",
        "primaryBorder": "#193085",
        "onPrimary": "#1A1028",
        "background": "#090E24",
        "background2": "#131A3D",
        "background3": "#0E1430",
        "surface": "#131A3D",
        "border": "#232C55",
        "textStrong": "#EEF1FB",
        "text": "#CBD3F0",
        "textSubtle": "#9AA6D6",
        "textMuted": "#8490C2"
      },
      "recipes": {
        "primary": {
          "pct": 55,
          "base": "#FFFFFF"
        },
        "primaryHover": {
          "pct": 42,
          "base": "#FFFFFF"
        },
        "primaryTint": {
          "pct": 26,
          "base": "#131A3D"
        },
        "primaryTint2": {
          "pct": 34,
          "base": "#131A3D"
        },
        "primaryTint3": {
          "pct": 13,
          "base": "#131A3D"
        },
        "primaryBorder": {
          "pct": 42,
          "base": "#131A3D"
        }
      }
    },
    "hc": {
      "colors": {
        "primary": "#9BBBFF",
        "primaryHover": "#B7CFFF",
        "primaryTint": "#11225D",
        "primaryTint2": "#13276D",
        "primaryTint3": "#0F1A43",
        "primaryBorder": "#142D82",
        "onPrimary": "#05081A",
        "background": "#05081A",
        "background2": "#121838",
        "background3": "#0A0E24",
        "surface": "#0B1026",
        "border": "#2A3358",
        "textStrong": "#FFFFFF",
        "text": "#FFFFFF",
        "textSubtle": "#FFFFFF",
        "textMuted": "#FFFFFF"
      },
      "recipes": {
        "primary": {
          "pct": 42,
          "base": "#FFFFFF"
        },
        "primaryHover": {
          "pct": 30,
          "base": "#FFFFFF"
        },
        "primaryTint": {
          "pct": 30,
          "base": "#0B1026"
        },
        "primaryTint2": {
          "pct": 38,
          "base": "#0B1026"
        },
        "primaryTint3": {
          "pct": 16,
          "base": "#0B1026"
        },
        "primaryBorder": {
          "pct": 48,
          "base": "#0B1026"
        }
      }
    }
  },
  "font": {
    "display": "Sora",
    "body": "Instrument Sans",
    "weights": {
      "Sora": [
        600,
        700,
        800
      ],
      "Instrument Sans": [
        400,
        500,
        600
      ]
    }
  },
  "space": {
    "1": 4,
    "2": 8,
    "3": 12,
    "4": 16,
    "5": 20,
    "6": 24,
    "8": 32,
    "10": 40,
    "12": 48,
    "16": 64
  },
  "radius": {
    "control": 10,
    "rail": 12,
    "card": 14,
    "modal": 16,
    "pill": 9999
  },
  "controlHeight": 38,
  "shadow": {
    "card": "2px 4px 12px rgba(0,0,0,0.08)",
    "modal": "0 12px 40px rgba(0,0,0,0.25)",
    "popover": "2px 4px 18px rgba(0,0,0,0.16)",
    "toast": "2px 4px 12px rgba(0,0,0,0.12)"
  },
  "transition": {
    "base": 150,
    "drawer": 200
  }
} as const

export type Tokens = typeof tokens
export type ColorToken = keyof Tokens["color"]
/** Nomes de tema aceitos em [data-theme] (alem de "system", que segue o SO). */
export type ThemeName = Exclude<keyof Tokens["theme"], "seed" | "halo">
